import { useMemo } from 'react';
import type { SunlightTimes } from 'types/sunlightTimes';
import getDayNightShadingBackground from './getDayNightShadingBackground';

export function useDayNightShadingBackground({
  sunlightTimes,
  dayIndex = 0,
  offset = 0,
}: {
  sunlightTimes: SunlightTimes;
  dayIndex?: number;
  offset?: number;
}) {
  return useMemo(
    () => ({
      background: getDayNightShadingBackground({ sunlightTimes, dayIndex, offset }),
    }),
    [sunlightTimes, dayIndex, offset],
  );
}
